import React, { useState, useEffect } from 'react'
import { Line, Bar, Pie } from "react-chartjs-2";
import { withFirebase } from '../../../services';
import firebase from 'firebase/app';
import 'firebase/firestore';
import history from '../../../common/history'
import like_img from '../../../assets/images/light-like-icon.png'
import message_img from '../../../assets/images/message.png'
import eye_img from '../../../assets/images/password-slow.png'
import logo from "../../../assets/images/mh-logo.png"
import moment from 'moment'

import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";

const Blog = () => {

  const [data, setData] = useState({
    totalViews: 0,
    totalContacts: 0,
    viewsTrend: [],
    searchCategoryStats: [],
    heatLocations: [],
    appointmentStats: [],
    appointmentTrend: [],
    ageStats: [],
    genderStats: [],
    ethnicityStats: [],
  });

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyA8CN_pG26FL8UWX22u5jvNOmiTRIyzLwE",
  });

useEffect(() => {
  const db = firebase.firestore();
  const email = firebase.auth().currentUser?.email;

  if (!email) return;

  fetchViews(db, email);
  fetchContacts(db, email);
  fetchSearchCategories(db);
  fetchAppointments(db, email);
  fetchDemographics(db, email);

}, []);

const fetchViews = async (db, email) => {
  const snap = await db
    .collection("providersViewed")
    .where("providerEmail", "==", email)
    .get();

  let total = 0;
  let locations = [];
  let daily = {};

  snap.forEach(doc => {
    const data = doc.data();

    // views
    if (data.searchDateTime) {
      total += data.searchDateTime.length;

      data.searchDateTime.forEach(ts => {
        const date = new Date(ts.seconds * 1000).toDateString();
        daily[date] = (daily[date] || 0) + 1;
      });
    }

    // heatmap
    if (data.userLocation) {
      data.userLocation.forEach(loc => {
        locations.push({
          lat: loc.latitude,
          lng: loc.longitude
        });
      });
    }
  });

  const trend = Object.keys(daily).map(date => ({
    date,
    value: daily[date]
  }));

  setData(prev => ({
    ...prev,
    totalViews: total,
    heatLocations: locations,
    viewsTrend: trend
  }));
};

const fetchContacts = async (db, email) => {
  const snap = await db
    .collection("providersContactedByPatients")
    .where("providerEmail", "==", email)
    .get();

  let total = 0;

  snap.forEach(doc => {
    total += doc.data().contactCount || 0;
  });

  setData(prev => ({
    ...prev,
    totalContacts: total
  }));
};

const fetchSearchCategories = async (db) => {
  const snap = await db.collection("searchedCategories").get();

  let counts = {};

  snap.forEach(doc => {
    const arr = doc.data().searchedParameter || [];

    arr.forEach(cat => {
      counts[cat] = (counts[cat] || 0) + 1;
    });
  });

  const result = Object.keys(counts).map(key => ({
    name: key,
    value: counts[key]
  }));

  setData(prev => ({
    ...prev,
    searchCategoryStats: result
  }));
};

const fetchAppointments = async (db, email) => {
  const snap = await db
    .collection("appointmentSchedules")
    .where("doctorEmail", "==", email)
    .get();

  let requested = 0;
  let confirmed = 0;

  let dailyReq = {};
  let dailyConf = {};

  snap.forEach(doc => {
    const d = doc.data();
    requested++;

    const status = (d.status || "").toLowerCase();
    const date = new Date(d.createdAt.seconds * 1000).toDateString();

    dailyReq[date] = (dailyReq[date] || 0) + 1;

    if (status === "confirmed") {
      confirmed++;
      dailyConf[date] = (dailyConf[date] || 0) + 1;
    }
  });

  const allDates = [...new Set([
    ...Object.keys(dailyReq),
    ...Object.keys(dailyConf)
  ])];

  const trend = allDates.map(date => ({
    date,
    requested: dailyReq[date] || 0,
    confirmed: dailyConf[date] || 0
  }));

  setData(prev => ({
    ...prev,
    appointmentStats: [
      { name: "Requested", value: requested },
      { name: "Confirmed", value: confirmed }
    ],
    appointmentTrend: trend
  }));
};

const fetchDemographics = async (db, email) => {
  const snap = await db
    .collection("appointmentSchedules")
    .where("doctorEmail", "==", email)
    .get();

  let age = {};
  let gender = {};
  let ethnicity = {};

  for (let doc of snap.docs) {
    const userEmail = doc.data().userEmail;
    if (!userEmail) continue;

    const userSnap = await db
      .collection("users")
      .where("email", "==", userEmail)
      .get();

    const user = userSnap.docs[0]?.data();
    if (!user) continue;

    const a = user.ageGroup || "NA";
    const g = user.gender || "NA";
    const e = user.ethinicity || "NA";

    age[a] = (age[a] || 0) + 1;
    gender[g] = (gender[g] || 0) + 1;
    ethnicity[e] = (ethnicity[e] || 0) + 1;
  }

  setData(prev => ({
    ...prev,
    ageStats: Object.keys(age).map(k => ({ name: k, value: age[k] })),
    genderStats: Object.keys(gender).map(k => ({ name: k, value: gender[k] })),
    ethnicityStats: Object.keys(ethnicity).map(k => ({ name: k, value: ethnicity[k] })),
  }));
};



  // ------------------ CHART HELPERS ------------------
  const lineChart = (labels, dataset, label) => ({
    labels,
    datasets: [
      {
        label,
        data: dataset,
        borderColor: "blue",
        fill: false,
      },
    ],
  });

  const barChart = (labels, dataset) => ({
    labels,
    datasets: [
      {
        label: "Count",
        data: dataset,
        backgroundColor: generateColors(dataset.length),
      },
    ],
  });

  const pieChart = (labels, dataset) => ({
    labels,
    datasets: [
      {
        data: dataset,
        backgroundColor: ["#3b82f6", "#22c55e", "#f59e0b", "#ef4444"],
      },
    ],
  });

  if (!isLoaded) return <div>Loading Map...</div>;

const chartOptions = {
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          precision: 0,     // ❗ removes decimals
          stepSize: 1,      // ❗ forces 1,2,3,4...
        }
      }
    ]
  }
};

const generateColors = (count) => {
  const colors = [
    "#3b82f6", // blue
    "#22c55e", // green
    "#f59e0b", // amber
    "#ef4444", // red
    "#8b5cf6", // purple
    "#06b6d4", // cyan
    "#ec4899", // pink
    "#84cc16", // lime
  ];

  return Array.from({ length: count }, (_, i) => colors[i % colors.length]);
};

  return (
    <div style={container}>

      {/* HEADER */}
      <div style={header}>
        <h1>Provider Dashboard</h1>
      </div>

      {/* OVERVIEW */}
       <div style={section}>
        <h2 style={sectionTitle}>Overview</h2>

        <div style={grid2}>
          <div style={kpiCard}>
            <p>Total Views</p>
            <h1 style={{ color: "#2563eb" }}>{data.totalViews}</h1>
          </div>

          <div style={kpiCard}>
            <p>Total Contacts</p>
            <h1 style={{ color: "#16a34a" }}>{data.totalContacts}</h1>
          </div>
        </div>
      </div>

      {/* USER INSIGHTS */}
      <div style={section}>
        <h2 style={sectionTitle}>User Insights</h2>

        <div style={grid2}>
          <div style={card}>
            <h3>User Locations</h3>
            <GoogleMap
              zoom={3}
              center={{ lat: 37.09, lng: -95.71 }}
              mapContainerStyle={{ height: "300px", width: "100%" }}
            >
              {data.heatLocations.map((loc, i) => (
                <Marker key={i} position={{ lat: loc.lat, lng: loc.lng }} />
              ))}
            </GoogleMap>
          </div>

          <div style={card}>
            <h3>Search Categories</h3>
            <Pie
              data={pieChart(
                data.searchCategoryStats.map(x => x.name),
                data.searchCategoryStats.map(x => x.value)
              )}
            />
          </div>
        </div>
      </div>

      {/* PERFORMANCE */}
      <div style={section}>
        <h2 style={sectionTitle}>Performance</h2>

        <div style={card}>
          <h3>Views Over Time</h3>
          <Line
            data={lineChart(
              data.viewsTrend.map(x => x.date),
              data.viewsTrend.map(x => x.value),
              "Views"
            )}
            options={chartOptions}
          />
        </div>
      </div>

      {/* APPOINTMENTS */}
      <div style={section}>
        <h2 style={sectionTitle}>Appointments</h2>

        <div style={grid2}>
          <div style={card}>
            <h3>Summary</h3>
            <Bar
              data={barChart(
                data.appointmentStats.map(x => x.name),
                data.appointmentStats.map(x => x.value)
              )}
              options={chartOptions}
            />
          </div>

          <div style={card}>
            <h3>Patients Over Time</h3>
            <Line
              options={chartOptions}
              data={{
                labels: data.appointmentTrend.map(x => x.date),
                datasets: [
                  {
                    label: "Requested",
                    data: data.appointmentTrend.map(x => x.requested),
                    borderColor: "blue",
                    fill: false,
                  },
                  {
                    label: "Confirmed",
                    data: data.appointmentTrend.map(x => x.confirmed),
                    borderColor: "green",
                    fill: false,
                  },
                ],
              }}
            />
          </div>
        </div>
      </div>

      {/* DEMOGRAPHICS */}
      <div style={section}>
        <h2 style={sectionTitle}>Demographics</h2>

        <div style={grid3}>
          <div style={card}>
            <h3>Age</h3>
            <Bar
              options={chartOptions}
              data={barChart(
                data.ageStats.map(x => x.name),
                data.ageStats.map(x => x.value)
              )}
            />
          </div>

          <div style={card}>
            <h3>Gender</h3>
            <Bar
              options={chartOptions}
              data={barChart(
                data.genderStats.map(x => x.name),
                data.genderStats.map(x => x.value)
              )}
            />
          </div>

          <div style={card}>
            <h3>Ethnicity</h3>
            <Bar
              options={chartOptions}
              data={barChart(
                data.ethnicityStats.map(x => x.name),
                data.ethnicityStats.map(x => x.value)
              )}
            />
          </div>
        </div>
      </div>

    </div>
  );
};

// ---------------- STYLES ----------------
const container = {
  padding: "30px 60px",
  background: "#f1f5f9",
  minHeight: "100vh",
  fontFamily: "Arial",
};

const header = {
  marginBottom: 30,
};

const section = {
  marginBottom: 40,
};

const sectionTitle = {
  marginBottom: 15,
  borderBottom: "2px solid #e2e8f0",
  paddingBottom: 5,
};

const grid2 = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 20,
};

const grid3 = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr",
  gap: 20,
};

const card = {
  background: "#fff",
  padding: 20,
  borderRadius: 12,
  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
};

const kpiCard = {
  ...card,
  textAlign: "center",
};

export default withFirebase(Blog);